import { render } from "./ConnectionDetails.vue?vue&type=template&id=b066320e"
import script from "./ConnectionDetails.vue?vue&type=script&lang=js"
export * from "./ConnectionDetails.vue?vue&type=script&lang=js"
script.render = render

export default script